import { initializeApp } from "firebase/app";
import { getAuth, initializeAuth, indexedDBLocalPersistence } from "firebase/auth";
import { Capacitor } from "@capacitor/core";

// Firebase web yapılandırması. Bu değerler herkese açıktır (gizli değildir) —
// güvenlik, Firebase Auth + güvenlik kurallarıyla sağlanır, apiKey'i gizlemekle değil.
const firebaseConfig = {
  apiKey: "AIzaSyB9mUSDpK8sM5DytEQkbB_XYuNRnKxM5go",
  authDomain: "pak-izmir.firebaseapp.com",
  projectId: "pak-izmir",
  storageBucket: "pak-izmir.firebasestorage.app",
  messagingSenderId: "151377640729",
  appId: "1:151377640729:web:c1809a8c5a1bd6209cd988",
  measurementId: "G-Y3Q15K8C79",
};

const app = initializeApp(firebaseConfig);

// Native (Capacitor) uygulamada standart getAuth() asılı kalabiliyor — özellikle
// iOS'ta scheme "capacitor://" olduğundan popup/redirect çözücüsü takılıyor ve
// onAuthStateChanged hiç ateşlenmiyor (sonsuz yükleme). Firebase'in resmî önerisi:
// native ortamda initializeAuth + indexedDBLocalPersistence (resolver'sız).
export const auth = Capacitor.isNativePlatform()
  ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
  : getAuth(app);

export default app;
